<template>
  <div class="address-page" v-loading="loading">
    <div class="head-box">
      <div class="hint">已保存收货地址（地址最多{{ count }}条，还能保存{{ count - addressList.length }}条）</div>
      <div class="new" @click="switchDialog">
        <div>新建地址</div>
        <div class="iconfont icon-jia2"></div>
      </div>
    </div>
    <el-empty v-if="addressList.length === 0" description="还没有添加地址，快去添加吧"></el-empty>

    <div v-else class="line-box" v-for="(item,index) in addressList" :key="index">
      <div class="title-box">
        <div class="title">
          <div>{{ item.consignee }}</div>
          <div v-if="item.isDefault" class="default">默认</div>
        </div>
        <div class="delete-box" @click="deleteAddress(item.id)">
          <div class="iconfont icon-shanchu"></div>
          <div>删除</div>
        </div>
      </div>

      <div class="content-box">
        <div class="name">
          姓名：
        </div>
        <div>
          {{ item.consignee }}
        </div>
      </div>

      <div class="content-box">
        <div class="name">
          地址：
        </div>
        <div>
          {{ item.province }}{{ item.city }}{{ item.district }}{{ item.address }}
        </div>
      </div>

      <div class="content-box edit">
        <div class="phone">
          <div class="name">
            手机：
          </div>
          <div>
            {{ item.phone }}
          </div>
        </div>
        <div class="edit-box">
          <div class="add-location" v-if="!item.isDefault" @click="setDefault(item)">
            设为默认地址
          </div>
          <div class="edit-hover" @click="switchDialog(item)">
            编辑
          </div>
        </div>
      </div>
    </div>
    <add-address-component v-if="showDialog" :item="item" :loading="loading"
                           @saveDialog="saveDialog"
                           @closeDialog="closeDialog"/>
  </div>
</template>


<script>
import {
  getAllAddress,
  addEnterpriseAddress,
  updateEnterpriseAddress,
  deleteEnterpriseAddress
} from '@/api/address'
import addAddressComponent from "@/components/addAddressComponent.vue";

export default {
  name: "location",
  components: {
    addAddressComponent
  },
  beforeMount() {
    this.getData();
  },
  data() {
    return {
      item: {},//编辑入参
      showDialog: false,
      loading: false,
      count: 8, //最大地址数量
      addressList: []
    }
  },
  methods: {
    switchDialog(item) {
      if (item.id) {
        // 编辑
        this.item = item
        this.showDialog = true;
      } else {
        // 新建
        if (this.count <= this.addressList.length) {
          this.$message.error("收货地址最多创建8个")
          return false;
        }
        this.showDialog = true;
      }
    },
    closeDialog() {
      this.item = {};
      this.showDialog = false
    },
    saveDialog(e) {
      if (e.id) {
        this.editAddress(e);
      } else {
        this.addAddress(e)
      }
    },
    getData() {
      this.loading = true;
      getAllAddress().then(result => {
        this.loading = false;
        if (result && result.code === "0") {
          this.addressList = result.data;
        } else {
          this.$message({
            type: 'error',
            message: result.msg
          });
        }
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '出错了！'
        });
      })
    },
    /**
     * 添加
     */
    addAddress(item) {
      this.loading = true;
      addEnterpriseAddress(item).then(result => {
        this.loading = false;
        if (result && result.code === "0") {
          this.item = {}
          this.showDialog = false;
          this.getData();
          this.$message({
            type: 'success',
            message: '添加成功!'
          });
        } else {
          this.$message({
            type: 'error',
            message: result.msg
          });
        }
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '出错了！'
        });
      })
    },
    /**
     * 删除
     */
    deleteAddress(id) {
      this.$confirm('此操作将删除该地址, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        deleteEnterpriseAddress(id).then(result => {
          this.loading = false;
          if (result && result.code === "0") {
            this.addressList = this.addressList.filter(item => item.id !== id)
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: result.msg
            });
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '出错了！'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    /**
     * 编辑
     */
    editAddress(item) {
      this.loading = true;
      updateEnterpriseAddress(item).then(result => {
        this.loading = false;
        if (result && result.code === "0") {
          this.item = {}
          this.showDialog = false;
          this.getData();
          this.$message({
            type: 'success',
            message: '编辑成功!'
          });
        } else {
          this.$message({
            type: 'error',
            message: result.msg
          });
        }

      }).catch(() => {
        this.$message({
          type: 'error',
          message: '出错了！'
        });
      })
    },
    /**
     * 设置默认地址
     */
    setDefault(item) {
      this.$confirm('此操作将设置该地址为默认地址, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        let params = {
          id: item.id,
          enterpriseId: item.enterpriseId,
          isDefault: true
        }
        updateEnterpriseAddress(params).then(result => {
          this.loading = false;
          if (result && result.code === "0") {
            this.getData();
            this.$message({
              type: 'success',
              message: '设置成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: result.msg
            });
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '出错了！'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "@/assets/css/szui.scss";

.address-page {
  padding: 30px 20px 30px;
  background: #FFFFFF;
  border-radius: 8px;

  .head-box {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .hint {
      font-size: 14px;
      font-weight: 400;
      color: #606366;
      line-height: 1;
    }

    .new {
      width: 94px;
      height: 30px;
      background: #F8F8F8;
      border: 1px solid #C0C4CC;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      font-size: 14px;
      font-weight: 400;
      color: $fontColor;
      line-height: 17px;

      .iconfont {
        margin-left: 5px;
        font-size: 12px;
      }
    }
  }

  .line-box {
    padding: 20px 24px 20px;
    margin-top: 30px;
    border: 1px solid #EDEFF2;
    border-radius: 10px;

    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: bold;
        color: $fontColor;

        .default {
          width: 40px;
          height: 22px;
          background: $main;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 14px;
          font-weight: 400;
          color: $fontColor;
          margin-left: 10px;
        }
      }

      .delete-box {
        display: flex;
        align-items: center;
        cursor: pointer;

        .iconfont {
          font-size: 12px;
          margin-right: 6px;
        }
      }
    }

    .content-box {
      margin-top: 16px;
      line-height: 1;
      display: flex;
      font-size: 14px;
      font-weight: 400;
      color: #606366;

      .phone {
        display: flex;

        .name {
          flex-shrink: 0;
        }
      }

      .edit-box {
        display: flex;
        font-size: 15px;
        font-weight: 400;
        color: #005EB1;
        line-height: 1;
        cursor: pointer;

        .add-location {
          margin-right: 30px
        }

        .add-location:hover {
          text-decoration: underline;
        }

        .edit-hover:hover{
          text-decoration: underline;

        }
      }
    }

    .edit {
      justify-content: space-between;
    }
  }
}

</style>